<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Radio, toast } from '@Shelly/shelly-design-system';
	//Seervices
	import { format } from 'svelte-i18n';
	import { localReq, postReq } from '../../../../../services/http';
	//Helpers
	import { get_local_ip, real_id } from '../../../../../helpers/interface_helpers';
	//Stores
	
	$: settingsStore = getDeviceSettings(id);
	export let device;

	const id = real_id(device.id);

	let settings = $settingsStore;
	let value = settings?.adcs[0].range;
	let cache = value;
	let localIp = get_local_ip(id);
	let loading = false;

	const setVoltage = async (val) => {
		value = val;
	};
	console.warn(settings);
	const sentRequest = async () => {
		if (cache !== value) {
			let res;
			loading = true;
			if (localIp) {
				res = await localReq(device, `${localIp}/settings/adc/0`, 'post', {
					range: value,
				});
			} else {
				res = await postReq(`/device/generic_command`, {
					id: real_id(device.id),
					command: 'adc_range',
					payload: JSON.stringify({ id: 0, range: value }),
				});
			}

			if (res.isok) {
				toast.open({
					type: 'success',
					title:
						$format('adc_range_changes_scc_toast', { values: { value } }) ||
						`Adc range was changed to ${value}v`,
				});
				settings.adcs[0].range = value;
				devices_settings.update_devices_settings(id, settings);
				cache = value;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				value = cache;
			}
			loading = false;
		}
	};
</script>

<Radio size="m" selected={value} value={12} on:click={() => setVoltage(12)} id="radio-2r824ru">12V</Radio
>
<Radio size="m" selected={value} value={30} on:click={() => setVoltage(30)} id="radio-aha935c">30V</Radio
>
<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequest}
	>{$format('button_save')}</Button
>
